import { v4 as uuidv4 } from 'uuid';
import { FlexLayoutCol, FlexLayoutRow } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Video } from '../../../../vtex-apps/Video/default';

export default function RichTextVideo() {
	return {
		componentName: 'FlexLayoutRow',
		componentId: uuidv4(),
		componentGroup: 'RichTextVideo',
		props: FlexLayoutRow({
			blockClass: 'richtext-video-2',
			mzTitle: 'MZ | Video SEO',
		}).props,
		variables,
		childrenComponents: [
			FlexLayoutCol(
				{
					blockClass: 'richtext-video-2-container',
				},
				[
					RichText({
						text: '## Texto SEO categoria',
						blockClass: 'richtext-title__rtv-2',
					}),
					Video({
						blockClass: 'richtext-video-2-video',
					}),
					RichText({
						text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consequat aliquam nunc non amet eget nunc dolor neque. Viverra massa netus cras fringilla nec elementum. Aenean leo malesuada cras integer eget quis. Laoreet non praesent nisl sociis. Scelerisque ipsum at enim, faucibus interdum. Vestibulum tellus vehicula malesuada orci, consequat. Donec orci tempus sagittis facilisis enim, aenean donec ac. \n ##### Subtítulo SEO \n Lorem ipsum dolor sit amet, consectetur adipiscing elit. Consequat aliquam nunc non amet eget nunc dolor neque. Viverra massa netus cras fringilla nec elementum. Aenean leo malesuada cras integer eget quis.\n Laoreet non praesent nisl sociis. Scelerisque ipsum at enim, faucibus interdum. Vestibulum tellus vehicula malesuada orci, consequat. Donec orci tempus sagittis facilisis enim, aenean donec ac. \n Laoreet non praesent nisl sociis. Scelerisque ipsum at enim, faucibus interdum. Vestibulum tellus vehicula malesuada orci, consequat. Donec orci tempus sagittis facilisis enim, aenean donec ac.',
						blockClass: 'richtext-text__rtv-2',
					}),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--transparent', to: '--rtv-2-bg-color', name: 'Background' },
			{ from: '--text-color-1', to: '--rtv-2-title-color', name: 'Title' },
			{ from: '--text-color-1', to: '--rtv-2-text-color', name: 'Body' },
		],
	},
	{
		type: 'fontWeight',
		list: [{ from: '--font-weight-700', to: '--rtv-2-title-fw', name: 'Title' }],
	},
	{
		type: 'fontSize',
		list: [
			{ from: '--font-size-xxxl', to: '--rtv-2-title-fs', name: 'Title Desktop' },
			{ from: '--font-size-sm', to: '--rtv-2-body-fs', name: 'Body Desktop' },
			{ from: '--font-size-xxl', to: '--rtv-2-title-fs-mobile', name: 'Title Mobile' },
			{ from: '--font-size-xs', to: '--rtv-2-body-fs-mobile', name: 'Body Mobile' },
		],
	},
	{
		type: 'typography',
		list: [
			{ from: '--main-font', to: '--rtv-2-title-ff', name: 'Heading' },
			{ from: '--main-font', to: '--rtv-2-body-ff', name: 'Body' },
		],
	},
];
